import { Box, Rating, styled, Typography } from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import "react-image-gallery/styles/css/image-gallery.css";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import { sendAnalytics } from "../../../utils/analyticsCommon";

const CustomNewVehicleReview = styled(Box)(({ theme }) => ({
  margin: "40px 0px",
  ".slider-box": {
    margin: "20px 20px 30px  20px",
    // width: "100%",
  },
  ".image-gallery-bullets-container": {
    position: "absolute",
    top: "30px",
    left: "40%",
  },
  ".image-gallery-bullet": {
    backgroundColor: "grey !important",
    boxShadow: "none !important",
  },
  ".image-gallery-bullet.active": {
    backgroundColor: "black !important",
  },

  ".headerInfo": {
    fontSize: "32px",
    fontWeight: "600",
  },

  ".subInfo": {
    fontSize: "12px",
    color: primary?.greyText,
    fontWeight: 600,
    textTransform: "uppercase",
  },
  ".rating": {
    fontSize: "80px",
    //lineHeight:"0px",
    fontWeight: 700,
    color: primary?.greyText,
  },
  "star-rating": { fontSize: "30px" },
  ".rating-number": {
    fontSize: "24px",
    color: primary?.greyText,
    fontWeight: 700,
  },

  [theme.breakpoints.down("md")]: {
    ".headerInfo": {
      fontSize: "24px",
      fontWeight: "600",
    },

    ".subInfo": {
      fontSize: "12px",
      color: primary?.greyText,
      fontWeight: 600,
      textTransform: "uppercase",
    },
    ".rating": {
      fontSize: "50px",
      //lineHeight:"0px",
      fontWeight: 700,
      color: primary?.greyText,
    },
    "star-rating": { fontSize: "12px" },
    ".rating-number": {
      fontSize: "10px",
      color: primary?.greyText,
      fontWeight: 700,
    },
  },
}));

const NewVehicleReview = ({ images, headerInfo, slidesPerView }) => {
  const [count, setCount] = useState(0);
  const { showConnectDrawer } = useContext(Context);
  const targetRef = useRef(null);
  // useEffect(() => {
  //   const options = {
  //     root: null,
  //     rootMargin: "0px",
  //     threshold: 0.8,
  //   };
  //   const observer = new IntersectionObserver((entries) => {
  //     const [entry] = entries;
  //     if (entry.isIntersecting) {
  //       sendAnalytics("scroll_rating_fold_form", {}, "en");
  //     }
  //   }, options);
  //   if (targetRef.current) observer.observe(targetRef.current);
  //   return () => {
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //     if (targetRef.current) observer.unobserve(targetRef.current);
  //   };
  // }, [targetRef]);

  return (
    <CustomNewVehicleReview>
      <Box id="ratings-and-reviews" ref={targetRef}>
        <Box style={{ display: "block", paddingLeft: "20px" }}>
          <Typography className="headerInfo">
            {headerInfo ?? "Vehicle reviews"}
          </Typography>
          <Typography className="subInfo">BY TURNO CUSTOMERS</Typography>

          <Box display="flex">
            <Typography className="rating">4.7</Typography>
            <Box
              display={"block"}
              sx={{
                justifyContent: "center",
                padding: {
                  xs: "16px 0px 10px 10px",
                  md: "30px 0px 20px 20px",
                  lg: "30px 0px 20px 20px",
                },
              }}
            >
              <Rating
                className="star-rating"
                defaultValue={4.7}
                precision={0.1}
                readOnly
                size="small"
                // style={{ fontSize: "12px" }}
              />
              <Typography className="rating-number">2,700+ Reviews</Typography>
            </Box>
          </Box>
        </Box>

        <Box>
          <Swiper
            slidesPerView={slidesPerView ?? 1.2}
            spaceBetween={0}
            centeredSlides={false}
            pagination={false}
            loop={true}
            modules={[Pagination]}
            className="swiper-turno-india"
            onSlideChange={() => {
              let newCount = count + 1;
              setCount(newCount);
              if (newCount > 1)
                sendAnalytics("v2_latest_model_slide", {}, "en");
            }}
          >
            {images?.map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <Box style={{ margin: "10px" }}>
                    <LazyLoadImage
                      src={data?.original}
                      style={{ width: "100%" }}
                      onClick={() => {
                        sendAnalytics(
                          "customer_review_call_request",
                          { type: "review_call_request", trigger: "whatsapp" },
                          "en"
                        );
                        showConnectDrawer("floater_whatsapp_icon");
                      }}
                      alt="customer_review_call_request image"
                    />
                  </Box>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>

        {/* <Box className="slider-box">
          <ImageGallery
            autoPlay={true}
            showNav={false}
            showBullets={true}
            style={{ height: "2px" }}
            items={images}
            showThumbnails={false}
            showFullscreenButton={false}
            showPlayButton={false}
            slideDuration={700}
          />
        </Box> */}
      </Box>
    </CustomNewVehicleReview>
  );
};

export default NewVehicleReview;
